/**
 * Laravel Echo options for this build, or null when the selected broadcaster is missing what it
 * needs (KALA-6439).
 *
 * The broadcaster is chosen as before: Reverb when VITE_REVERB_HOST is set, otherwise Pusher.
 * pusher-js throws in its constructor without a key or a cluster, and that throw stops the whole
 * bundle, so a missing value means "do not construct Echo". An empty value is treated the same way:
 * it does not throw, but it can never connect.
 *
 * Kept free of imports so `npm run test:js` can test it in Node, with no browser and no build.
 *
 * @param {Record<string, string|undefined>} env  import.meta.env
 * @returns {object|null}
 */
export function echoOptions(env) {
    const reverbHost = env.VITE_REVERB_HOST;

    if (filled(reverbHost)) {
        return filled(env.VITE_REVERB_APP_KEY) ? reverbOptions(env, reverbHost) : null;
    }

    return filled(env.VITE_PUSHER_APP_KEY) && filled(env.VITE_PUSHER_APP_CLUSTER) ? pusherOptions(env) : null;
}

function filled(value) {
    return typeof value === 'string' && value.trim() !== '';
}

function reverbOptions(env, host) {
    const port = Number(env.VITE_REVERB_PORT) || 8080;

    return {
        broadcaster: 'pusher',
        key: env.VITE_REVERB_APP_KEY,
        cluster: 'mt1',
        wsHost: host,
        wsPort: port,
        wssPort: port,
        forceTLS: env.VITE_REVERB_SCHEME === 'https',
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
    };
}

function pusherOptions(env) {
    return {
        broadcaster: 'pusher',
        key: env.VITE_PUSHER_APP_KEY,
        cluster: env.VITE_PUSHER_APP_CLUSTER,
        forceTLS: true,
    };
}
